<template>
  <div class="g-photo-wrap2">
    <div v-for="(imgUrl,index) in url"  style="position: relative;margin-top: 2px" @click="$emit('remove',index)">
      <img class="pic" :src="imgUrl"/>
      <span style="background: red;color: white;position: absolute;right: 2px;top: 2px;border-radius: 2em;padding: 2px;line-height: 10px">×</span>
    </div>
<!--    <img alt="" v-src="defaultUrl" class="g-photo">-->
    <div class="g-upload" style="text-align: center">
      <div style="width: 72px;position: relative;margin: 0 auto">
        <input type="file"
               accept="image/jpeg,image/jpg,/image/png"
               class="g-upload-input"
               ref="file"
               @change="$emit('change',$event,$el)"
        >
        <a style="text-align: center"><img :src="require('@img/upload.png')" alt="" class="icon"></a>
        <p>{{ label }}</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'VPhoto2',
  props: {
    url: '',
    defaultUrl: require('@img/default-img.png'),
    label: [String]
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var.scss";
.g-photo-wrap2 {
  background: $color-bg;
  padding: 10px;
  text-align: center;
  //height: 146px;
  //display: flex;
  //display: -webkit-flex;
  //align-items: center;
  //justify-content: center;
  position: relative;
  max-width: 300px;
  margin: auto;
  //overflow: hidden;
  .g-photo {
    //position: absolute;
    z-index: 1;
    width: 100%;
  }
  .g-upload {
    position: relative;
    z-index: 3;
    color: #666666;
    .icon {
      position: absolute;
      width: 74px;
      left: 0;
    }
    .g-upload-input {
      position: relative;
      z-index: 999;
      width: 100%;
      height: 74px;
      opacity: 0;
      transform: translateZ(0)
    }
  }
}
.pic{
  width: 300px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/base/photo2.vue